import { DeclineReasonType } from './DeclineReasonType';

export const DeclineReasonTypeOptions = [
    {
        key: DeclineReasonType.CreditHistory,
        sortOrder: 2,
        name: 'Credit History',
        info: 'Insufficient number of credit references provided; Unacceptable type of credit references provided; No credit file; Limited credit experience; Poor credit performance with us; Delinquent past or present credit obligations with others; Number of recent inquiries on credit bureau report; Garnishment, attachment, foreclosure, repossession, collection action, or judgment; and Bankruptcy',
    },
    {
        key: DeclineReasonType.Collateral,
        sortOrder: 1,
        name: 'Collateral',
        info: 'Value or type of collateral not sufficient such as not meeting minimum size',
    },
    {
        key: DeclineReasonType.Other,
        sortOrder: 4,
        name: 'Other',
        info: 'Enter specific reasons for denial',
    },
    {
        key: DeclineReasonType.BackgroundIssue,
        sortOrder: 0,
        name: 'Background Issue',
        info: "A background check on the borrower revealed results not included on the borrower's S1 form",
    },
    {
        key: DeclineReasonType.UnableToVerifyIdentity,
        sortOrder: 3,
        name: 'Unable To Verify Identity',
        info: 'Identification information was not provided or was incomplete',
    },
];
